import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { SolicitudesOrdenesFisicasService } from 'src/app/services/empresa/solicitudes-ordenes-fisicas.service';

@Component({
    selector: 'app-ordenes-fisicas-seguimiento-blocks',
    templateUrl: './ordenes-fisicas-seguimiento-blocks.component.html',
    styleUrls: ['./ordenes-fisicas-seguimiento-blocks.component.scss'],
    standalone: false
})
export class OrdenesFisicasSeguimientoBlocksComponent implements OnInit {

  public solicitud = '';
  public secuencia = '';
  public precio2D = '';
  public numeroBlocks = '';

  public desde = '';
  public hasta = '';
  public totalDisponibles = 0;
  public cargando = false;
  public venidoDeBusquedaDirecta = false;

  public blocks: any[] = [];
  public filtroSecuencia = '';
  public blocksGlobales: any[] = [];
  public modoGlobal = false;
  public buscandoGlobal = false;

  public blockSeleccionado = '';
  public secuenciasBlock: any[] = [];
  public asesores: any[] = [];
  public doctores: any[] = [];
  public bloqueEdicion: any = null;
  public secuenciaEdicion: any = null;
  public doctorBusqueda = '';
  public tipoBusquedaOrden = 'NOM_CLI';
  public busquedaOrden = '';
  public ordenesBusqueda: any[] = [];
  public buscandoOrdenes = false;
  public guardandoAsignacion = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private solicitudesService: SolicitudesOrdenesFisicasService
  ) {}

  ngOnInit(): void {
    const busquedaGlobal = this.route.snapshot.queryParamMap.get('busquedaGlobal') || '';

    if (busquedaGlobal) {
      this.filtroSecuencia = busquedaGlobal;
      this.venidoDeBusquedaDirecta = true;
      this.cargarAsesores();
      this.buscarGlobal();
      return;
    }

    this.solicitud = this.route.snapshot.queryParamMap.get('solicitud') || '';
    this.secuencia = this.route.snapshot.queryParamMap.get('secuencia') || '';
    this.precio2D = this.route.snapshot.queryParamMap.get('precio2D') || '';
    this.numeroBlocks = this.route.snapshot.queryParamMap.get('numeroBlocks') || '';

    const rangos = this.secuencia.split(' - ').map((item) => item.trim());
    this.desde = rangos[0] || '';
    this.hasta = rangos[1] || '';

    if (!this.solicitud || !this.desde || !this.hasta) {
      this.toastr.error('Parámetros incompletos para visualizar blocks.', 'Atención', {
        timeOut: 3000,
        closeButton: true,
        progressBar: true
      });
      this.router.navigate(['/sistema/ordenes-fisicas-solicitudes']);
      return;
    }

    this.cargarDatos();
    this.cargarAsesores();
  }

  cargarDatos() {
    this.cargando = true;

    this.solicitudesService.totalBlocksDisponibles(
      localStorage.getItem('token') || '',
      this.solicitud,
      this.desde,
      this.hasta
    ).subscribe({
      next: (resp: any) => {
        const rows = Array.isArray(resp) ? resp : resp?.rows ?? [];
        this.totalDisponibles = Number(rows[0]?.TOTAL ?? 0);
      },
      error: () => { this.totalDisponibles = 0; }
    });

    this.solicitudesService.listarBlocksSeguimiento(
      localStorage.getItem('token') || '',
      this.solicitud,
      this.desde,
      this.hasta
    ).subscribe({
      next: (resp: any) => {
        const rows = Array.isArray(resp) ? resp : resp?.rows ?? [];
        this.blocks = rows;
        this.cargando = false;
      },
      error: () => {
        this.blocks = [];
        this.cargando = false;
      }
    });
  }

  cargarAsesores() {
    this.solicitudesService.listarAsesores(localStorage.getItem('token') || '').subscribe({
      next: (resp: any) => {
        this.asesores = Array.isArray(resp) ? resp : resp?.rows ?? [];
      },
      error: () => { this.asesores = []; }
    });
  }

  get globalDisponibles(): number {
    return this.blocksGlobales.filter((b) => b.RESULTADO === 'DISPONIBLE').length;
  }

  get blocksFiltrados(): any[] {
    if (this.modoGlobal) {
      return this.blocksGlobales;
    }

    const filtro = this.filtroSecuencia.trim().toUpperCase();

    if (!filtro) {
      return this.blocks;
    }

    return this.blocks.filter((item) =>
      String(item.NUM_SECORD || '').toUpperCase().includes(filtro)
      || String(item.NUMSIS_BLOCKS || '').toUpperCase().includes(filtro)
    );
  }

  buscarGlobal(): void {
    const termino = this.filtroSecuencia.trim();

    if (termino.length < 2) {
      return;
    }

    this.buscandoGlobal = true;
    this.modoGlobal = false;

    this.solicitudesService.buscarBlocksGlobal(
      localStorage.getItem('token') || '',
      termino
    ).subscribe({
      next: (resp: any) => {
        this.buscandoGlobal = false;
        this.blocksGlobales = Array.isArray(resp) ? resp : resp?.rows ?? [];
        this.modoGlobal = true;
      },
      error: () => {
        this.buscandoGlobal = false;
        this.blocksGlobales = [];
        this.modoGlobal = true;
      }
    });
  }

  limpiarBusquedaGlobal(): void {
    if (this.venidoDeBusquedaDirecta) {
      this.router.navigate(['/sistema/ordenes-fisicas-solicitudes']);
      return;
    }

    this.modoGlobal = false;
    this.blocksGlobales = [];
    this.filtroSecuencia = '';
  }

  abrirSecuencias(modal: any, block: any) {
    this.blockSeleccionado = String(block.NUMSIS_BLOCKS || '');
    this.secuenciasBlock = [];

    this.solicitudesService.listarSecuenciasPorBlock(localStorage.getItem('token') || '', this.blockSeleccionado).subscribe({
      next: (resp: any) => {
        const rows = Array.isArray(resp) ? resp : resp?.rows ?? [];
        this.secuenciasBlock = rows;
        this.modalService.open(modal, { centered: true, size: 'xl' });
      },
      error: () => {
        this.secuenciasBlock = [];
        this.modalService.open(modal, { centered: true, size: 'xl' });
      }
    });
  }

  recargarSecuenciasActuales() {
    if (!this.blockSeleccionado) {
      return;
    }

    this.solicitudesService.listarSecuenciasPorBlock(localStorage.getItem('token') || '', this.blockSeleccionado).subscribe({
      next: (resp: any) => {
        const rows = Array.isArray(resp) ? resp : resp?.rows ?? [];
        this.secuenciasBlock = rows;
      },
      error: () => { this.secuenciasBlock = []; }
    });
  }

  abrirAsignarAsesor(modal: any, block: any) {
    this.bloqueEdicion = block;
    this.modalService.open(modal, { centered: true, size: 'lg' });
  }

  abrirAsignarDoctor(modal: any, block: any) {
    this.bloqueEdicion = block;
    this.secuenciaEdicion = null;
    this.doctores = [];
    this.doctorBusqueda = '';
    this.modalService.open(modal, { centered: true, size: 'lg' });
  }

  abrirAsignarDoctorSecuencia(modal: any, secuencia: any) {
    this.secuenciaEdicion = secuencia;
    this.bloqueEdicion = null;
    this.doctores = [];
    this.doctorBusqueda = '';
    this.modalService.open(modal, { centered: true, size: 'lg' });
  }

  abrirAsignarOrdenSecuencia(modal: any, secuencia: any) {
    this.secuenciaEdicion = secuencia;
    this.bloqueEdicion = null;
    this.tipoBusquedaOrden = 'NOM_CLI';
    this.busquedaOrden = '';
    this.ordenesBusqueda = [];
    this.buscandoOrdenes = false;
    this.modalService.open(modal, { centered: true, size: 'lg' });
  }

  tieneAsignacionSecuencia(secuencia: any): boolean {
    const doctor = String(secuencia?.NOMDOC_SECORD || '').trim();
    const paciente = String(secuencia?.CLI_SECORD || '').trim();
    return doctor.length > 0 || paciente.length > 0;
  }

  buscarDoctores() {
    this.solicitudesService.buscarDoctores(localStorage.getItem('token') || '', this.doctorBusqueda).subscribe({
      next: (resp: any) => {
        this.doctores = Array.isArray(resp) ? resp : resp?.rows ?? [];
      },
      error: () => { this.doctores = []; }
    });
  }

  asignarAsesor(asesor: any) {
    if (!this.bloqueEdicion?.COD_BLOCKS) {
      return;
    }

    this.guardandoAsignacion = true;

    this.solicitudesService.asignarAsesor(
      localStorage.getItem('token') || '',
      String(this.bloqueEdicion.COD_BLOCKS),
      String(asesor.id),
      String(asesor.nombre || ''),
      String(this.precio2D || 0)
    ).subscribe({
      next: () => {
        this.guardandoAsignacion = false;
        this.toastr.success('Asesor asignado correctamente.', 'Atención', {
          timeOut: 2500,
          closeButton: true,
          progressBar: true
        });
        this.modalService.dismissAll();
        this.cargarDatos();
      },
      error: () => {
        this.guardandoAsignacion = false;
        this.toastr.error('No se pudo asignar el asesor.', 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
      }
    });
  }

  asignarDoctor(doctor: any) {
    if (!this.bloqueEdicion?.COD_BLOCKS) {
      return;
    }

    this.guardandoAsignacion = true;

    this.solicitudesService.asignarDoctor(
      localStorage.getItem('token') || '',
      String(this.bloqueEdicion.COD_BLOCKS),
      String(doctor.CodVendedor || ''),
      String(doctor.NombreVendedor || '')
    ).subscribe({
      next: () => {
        this.guardandoAsignacion = false;
        this.toastr.success('Doctor asignado correctamente.', 'Atención', {
          timeOut: 2500,
          closeButton: true,
          progressBar: true
        });
        this.modalService.dismissAll();
        this.cargarDatos();
      },
      error: () => {
        this.guardandoAsignacion = false;
        this.toastr.error('No se pudo asignar el doctor.', 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
      }
    });
  }

  asignarDoctorSecuencia(doctor: any) {
    if (!this.secuenciaEdicion?.COD_SECORD) {
      return;
    }

    this.guardandoAsignacion = true;

    this.solicitudesService.asignarDoctorSecuencia(
      localStorage.getItem('token') || '',
      String(this.secuenciaEdicion.COD_SECORD),
      String(doctor.CodVendedor || ''),
      String(doctor.NombreVendedor || '')
    ).subscribe({
      next: () => {
        this.guardandoAsignacion = false;
        this.toastr.success('Doctor actualizado en la secuencia.', 'Atención', {
          timeOut: 2500,
          closeButton: true,
          progressBar: true
        });
        this.modalService.dismissAll();
        this.recargarSecuenciasActuales();
        this.cargarDatos();
      },
      error: () => {
        this.guardandoAsignacion = false;
        this.toastr.error('No se pudo actualizar el doctor de la secuencia.', 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
      }
    });
  }

  buscarOrdenesParaSecuencia() {
    if (!this.secuenciaEdicion?.NUM_SECORD) {
      return;
    }

    this.buscandoOrdenes = true;

    this.solicitudesService.buscarOrdenesParaSecuencia(
      localStorage.getItem('token') || '',
      this.tipoBusquedaOrden,
      this.busquedaOrden
    ).subscribe({
      next: (resp: any) => {
        this.buscandoOrdenes = false;
        this.ordenesBusqueda = Array.isArray(resp) ? resp : resp?.rows ?? [];
      },
      error: () => {
        this.buscandoOrdenes = false;
        this.ordenesBusqueda = [];
      }
    });
  }

  asignarOrdenASecuencia(orden: any) {
    if (!this.secuenciaEdicion?.NUM_SECORD || !orden?.COD_ORD) {
      return;
    }

    this.guardandoAsignacion = true;

    this.solicitudesService.asignarOrdenSecuencia(
      localStorage.getItem('token') || '',
      String(this.secuenciaEdicion.NUM_SECORD || ''),
      String(orden.COD_ORD || '')
    ).subscribe({
      next: () => {
        this.guardandoAsignacion = false;
        this.toastr.success('Orden asignada correctamente a la secuencia.', 'Atención', {
          timeOut: 2500,
          closeButton: true,
          progressBar: true
        });
        this.modalService.dismissAll();
        this.recargarSecuenciasActuales();
        this.cargarDatos();
      },
      error: () => {
        this.guardandoAsignacion = false;
        this.toastr.error('No se pudo asignar la orden a la secuencia.', 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
      }
    });
  }

  diasSinAsignacion(item: any): string {
    if (!item?.FECASIGASE_BLOCK) {
      return '0';
    }

    const fechaInicio = new Date(item.FECASIGASE_BLOCK);
    const fechaFin = item?.FECASIGDOC_BLOCK ? new Date(item.FECASIGDOC_BLOCK) : new Date();

    const diffMs = Math.abs(fechaFin.getTime() - fechaInicio.getTime());
    return String(Math.floor(diffMs / (1000 * 60 * 60 * 24)));
  }
}
